import { bg3, img19, img19_2 } from "../assets";
import useDevice from "../util";

const PromotionPath = ({ promotionPathRef }) => {
  const device = useDevice();
  return (
    <div
      ref={promotionPathRef}
      className="w-screen h-auto bg-[white] flex items-center flex-col relative"
    >
      <img
        className="object-fill absolute z-[0] w-screen h-[500px] bottom-[-1px]"
        src={bg3}
        alt=""
      />
      <div className="flex flex-col items-center">
        <div className="text-[#333333] text-[24px] sm:text-[28px] font-[700]  mb-[35px] mt-[40px] flex flex-col	items-center">
          <div className="text-center">LỘ TRÌNH THĂNG TIẾN</div>
          <div className="w-[166px] border-b-[6px] border-[#005DD7] mt-[15px]"></div>
        </div>
        <div className="text-[#767676] text-[20px] sm:text-[28px] font-[400] ">
          Rõ ràng làm chủ bản thân và sự nghiệp
        </div>
      </div>
      <div className="relative min-h-[100vw] sm:min-h-[650px] w-[1116px] max-w-[100vw] overflow-hidden">
        {device !== "mobile" ? (
          <img
            className="absolute z-[2] bottom-[-111px] min-w-[893px] min-h-[893px] left-[50%] -translate-x-[50%]"
            src={img19}
            alt=""
          />
        ) : (
          <img
            className="absolute z-[2] bottom-[-108px] w-[100vw] min-h-[555px] left-[50%] -translate-x-[50%]"
            src={img19_2}
            alt=""
          />
        )}
      </div>
    </div>
  );
};

export default PromotionPath;
